import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ContactPanelItemComponent } from "./contact-panel-item.component";
import { SharedModule } from "src/app/shared/shared.module";
import { TranslateModule } from "@ngx-translate/core";

@NgModule({
  imports: [CommonModule, SharedModule, TranslateModule],
  exports: [ContactPanelItemComponent],
  declarations: [ContactPanelItemComponent],
})
export class ContactPanelItemModule {}
